import { render, staticRenderFns } from "./FormCrear.vue?vue&type=template&id=199d4f70&scoped=true&"
import script from "./FormCrear.vue?vue&type=script&lang=ts&"
export * from "./FormCrear.vue?vue&type=script&lang=ts&"
import style0 from "./FormCrear.vue?vue&type=style&index=0&id=199d4f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d4f70",
  null
  
)

export default component.exports